export const selectTrainingType = [
  {
    id: 1,
    value: 'external',
    name: 'external',
  },
  {
    id: 2,
    value: 'internal',
    name: 'internal',
  },
  {
    id: 3,
    value: 'online',
    name: 'online',
  },
];
